import React, { useState, useContext } from "react";
import { observer } from "mobx-react";
import { DateTime } from "luxon";

import MyBetsBetItemDetailsToggleButton from "./MyBetsBetItemDetailsToggleButton";
import { EventOfferGroups } from "@features/my-bets/mobile/common/event-offer-groups";
import ShareBetSlipButton from "@features/my-bets/mobile/common/ShareBetSlipButton";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import classnames from "classnames";

export default observer(function MyBetsPageBetItemDetails() {
	const [isDetailsOpen, setIsDetailsOpen] = useState(false);
	const bet = useContext(MyBetsBetContext);

	const betMiniFooterClassNames = classnames("bet--mini__footer__inner", {
		"is-expanded": isDetailsOpen,
		"is-collapsed": !isDetailsOpen,
	});

	return (
		<div className="bet--mini__footer">
			<div className={betMiniFooterClassNames}>
				<div className="bet--mini__footer__info">
					<span className="bet--mini__date">
						{DateTime.fromISO(bet.dateCreated).toFormat(
							"dd.MM.yy HH:mm"
						)}
					</span>
					<span className="bet--mini__date">
						ID: {bet.betSlipNumber}
					</span>
					<div
						className="bet--mini__share"
						style={{ display: "flex", justifyContent: "start" }}
					>
						<ShareBetSlipButton bet={bet} btnTiny label={false} />
					</div>
				</div>
				<div>
					<MyBetsBetItemDetailsToggleButton
						isDetailsOpen={isDetailsOpen}
						setIsDetailsOpen={setIsDetailsOpen}
					/>
				</div>
			</div>

			{isDetailsOpen && (
				<div className="bet bet--mini__inner">
					<EventOfferGroups offersHaveColor />
				</div>
			)}
		</div>
	);
});
